/*
  ImpedanceModeling: [
    { name: "L1",
      impedances: [ 
       { mhz: 100, characteristicImpedance: xxx, differentialImpedance: yyy, propagationalDelay: zzz }
       { mhz: 500, characteristicImpedance: xxx, differentialImpedance: yyy, propagationalDelay: zzz }
       { mhz: 1000, characteristicImpedance: xxx, differentialImpedance: yyy, propagationalDelay: zzz }
       { mhz: 2000, characteristicImpedance: xxx, differentialImpedance: yyy, propagationalDelay: zzz }
       { mhz: 5000, characteristicImpedance: xxx, differentialImpedance: yyy, propagationalDelay: zzz }
       { mhz: 10000, characteristicImpedance: xxx, differentialImpedance: yyy, propagationalDelay: zzz }
     ],
     ...rest
    },
    { name: "L2",
      impedances: [ 
       { mhz: 100, characteristicImpedance: xxx, differentialImpedance: yyy, propagationalDelay: zzz }
       { mhz: 500, characteristicImpedance: xxx, differentialImpedance: yyy, propagationalDelay: zzz }
       { mhz: 1000, characteristicImpedance: xxx, differentialImpedance: yyy, propagationalDelay: zzz }
       { mhz: 2000, characteristicImpedance: xxx, differentialImpedance: yyy, propagationalDelay: zzz }
       { mhz: 5000, characteristicImpedance: xxx, differentialImpedance: yyy, propagationalDelay: zzz }
       { mhz: 10000, characteristicImpedance: xxx, differentialImpedance: yyy, propagationalDelay: zzz }
     ],
     ...rest
    }
  ];
  Format of CharData
  Chart Data:  {
    data: [
      { L1: xxx, mhz: "100" },
      { L1: xxx, mhz: "500" },
      { L1: xxx, mhz: "1000" },
      { L1: xxx, mhz: "2000" },
      { L1: xxx, mhz: "5000" },
      { L1: xxx, mhz: "10000" },
      { L2: xxx, mhz: "100" },
      { L2: xxx, mhz: "500" },
      { L2: xxx, mhz: "1000" },
      { L2: xxx, mhz: "2000" },
      { L2: xxx, mhz: "5000" },
      { L2: xxx, mhz: "10000" },
    ],
    keys: [ "L1", "L2" ],
    mhzs: [ "100", "500", "1000", "2000", "5000", "10000" ]
  }
*/
export function mapImpedanceModelingsToChartData(impedanceModelings, property) {
  const modelingsWithImpedance = impedanceModelings
    .filter(modeling => modeling.impedances);
  const keys = modelingsWithImpedance.map(m => m.name);
  const mhzs = mapImpedanceModelingsToMhzs(impedanceModelings).map(mhz => mhz.toString());
  const data = modelingsWithImpedance
    .reduce((nodes, modeling) => [
        ...nodes,
        ...modeling.impedances.map(i => ({
           [modeling.name]: typeof i[property] === 'number' ? i[property].toFixed(2) : 'N/A',
           mhz: i.mhz.toString()
        }))
      ], []
    );
  return { data, keys, mhzs }
}


export function mapImpedanceModelingsToMhzs(impedanceModelings) {
  const modelingWithImpedance = impedanceModelings
    .find(modeling => modeling.impedances);

  return modelingWithImpedance
    ? modelingWithImpedance.impedances.map(x => x.mhz)
    : []
}


// WEBPACK FOOTER //
// ./src/lib/simulations/chartData.js